import React from "react";
import styles from "./bottom-cta.module.scss";
import { useTranslation } from "react-i18next";
import { FixButton } from "@/elements-react/fix-button";
import {Url} from "@/helpers/url.ts";

export interface BottomCtaProps {
    onButtonClick?: () => void;
}

export const BottomCta: React.FC<BottomCtaProps> = ({ onButtonClick }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.textContainer}>
                <h2 className={styles.title}>
                    {t("Ready to work more comfortably?")}
                </h2>
                <p className={styles.subtitle}>
                    {t("Register for B2B access and manage your auto parts orders with confidence")}
                </p>
            </div>

            <div className={styles.buttonContainer}>
                <FixButton
                    variant="primary"
                    onClick={onButtonClick}
                    className={styles.button}
                    href={Url.to("signup-page")}
                >
                    {t("Become a business customer")}
                </FixButton>
            </div>
        </div>
    );
};
